import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {WhatConnectionType} from "../../../../components/help/CommonQuestions.tsx";
import Icon from "../../../../components/selfcare/Icon.tsx";
import IconOpenInNew from "../../../../components/icons/IconOpenInNew.tsx";

export default function InstallationManualArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Skal du have hjælp til at sætte din router op?
                            Download vores installationsvejledning og så guider vi dig med installationen af udstyret og aktiveringen af din internetforbindelse.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <h2>Manualer</h2>
                    <div className={'button-container'}>
                        <a
                            href={'/fiber-manual'}
                            className={'button button--montserrat with-icon teal'}
                            target={'_blank'}
                        >
                            <span className={'text'}>Fiber: <span className={'normal-fw'}>Generel</span></span>
                            <Icon component={IconOpenInNew}/>
                        </a>
                        <a
                            href={'/fiber-vejledning-ewii-tdc'}
                            className={'button button--montserrat with-icon teal'}
                            target={'_blank'}
                        >
                            <span className={'text'}>Fiber: <span className={'normal-fw'}>EWII og TDC NET</span></span>
                            <Icon component={IconOpenInNew}/>
                        </a>
                        <a
                            href={'/5g-internet-vejledning'}
                            className={'button button--montserrat with-icon teal'}
                            target={'_blank'}
                        >
                            <span className={'text'}>5G-internet: <span className={'normal-fw'}>Zyxel router</span></span>
                            <Icon component={IconOpenInNew}/>
                        </a>
                        <a
                            href={'/5g-internet-vejledning-huawei'}
                            className={'button button--montserrat with-icon teal'}
                            target={'_blank'}
                        >
                            <span className={'text'}>5G-internet: <span className={'normal-fw'}>Huawei router</span></span>
                            <Icon component={IconOpenInNew}/>
                        </a>
                        <a
                            href={'/kabel-tv-stik-vejledning'}
                            className={'button button--montserrat with-icon teal'}
                            target={'_blank'}
                        >
                            <span className={'text'}>Kabel-tv-stik</span>
                            <Icon component={IconOpenInNew}/>
                        </a>
                        <a
                            href={'/wifi-mesh-vejledning'}
                            className={'button button--montserrat with-icon teal'}
                            target={'_blank'}
                        >
                            <span className={'text'}>Wifi-mesh</span>
                            <Icon component={IconOpenInNew}/>
                        </a>
                    </div>
                    <div className="paragraph">
                        <p>
                            Du modtager også installationsmanualen sammen med din router, hvor du nemt bliver guidet igennem hele tilslutningen af routeren.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h3>{WhatConnectionType.question}</h3>
                        {WhatConnectionType.answer}
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "skift-navn-og-kode-paa-wifi",
                        "name": "Skift navn og kode på wifi"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "forskel-paa-signal-frekvenser",
                        "name": "Forskellen på 2,4- og 5 GHz"
                    }
                ]}
            />
        </>
    )
}
